module.exports = __webpack_public_path__ + "278ed926ae7b04881026eb79c4907151.svg";